import { Dispatch, SetStateAction, useCallback, useState } from "react";
import {
  ReactZoomPanPinchRef,
  TransformComponent,
  TransformWrapper,
} from "react-zoom-pan-pinch";
import { EcgLeads } from "../../../api/index.defs";
import { Constants } from "../../../constants";
import { round } from "../../../utils/sharedUtil";
import EcgGraph from "../EcgGraph/EcgGraph";
import styles from "./EcgTransform.module.css";

type EcgTransformProps = {
  graph: EcgLeads;
  setZoomPanRef?: Dispatch<SetStateAction<ReactZoomPanPinchRef | undefined>>;
};

const EcgTransform = ({ graph, setZoomPanRef }: EcgTransformProps) => {
  const elRef = useCallback((ref: ReactZoomPanPinchRef) => {
    if (!setZoomPanRef) return;
    return setZoomPanRef(ref);
  }, [setZoomPanRef]);

  const getZoomFromScale = (scale: number) => {
    return round(scale, 1) * 100;
  };

  const [zoomLevel, setZoomLevel] = useState<number>(
    getZoomFromScale(Constants.MIN_ZOOM_SCALE)
  );

  return (
    <TransformWrapper
      initialScale={Constants.MIN_ZOOM_SCALE}
      minScale={Constants.MIN_ZOOM_SCALE}
      maxScale={Constants.MAX_ZOOM_SCALE}
      limitToBounds={true}
      centerZoomedOut={true}
      wheel={{
        step: Constants.ZOOM_SCALE_STEP,
      }}
      pinch={{
        step: Constants.ZOOM_SCALE_STEP,
      }}
      onZoom={({ state: { scale } }) => {
        setZoomLevel(getZoomFromScale(scale));
      }}
      panning={{
        disabled: zoomLevel === getZoomFromScale(Constants.MIN_ZOOM_SCALE),
      }}
      ref={elRef}
    >
      <TransformComponent
        wrapperClass={`m-sm-2 ${styles.zoomWrapper}`}
        contentClass="h-100"
      >
        <div
          className={`h-100 d-flex align-items-sm-center ${
            styles.zoomContent
          } ${zoomLevel !== 100 ? "cursor-drag" : ""}`}
        >
          <EcgGraph graph={graph} />
        </div>
      </TransformComponent>
    </TransformWrapper>
  );
};

export default EcgTransform;
